// Widget Scripts
import mainSlider from './js/widgets/mainSlider.js';
import eventsWidget from './js/widgets/eventsWidget.js';
import cardsWidget from './js/widgets/cardsWidget.js';
import * as socialNetworkWidget from './js/widgets/socialWidget.js';
import hotButtonsWidget from './js/widgets/hotButtonsWidget.js';
import videoWidget from './js/widgets/videoWidget.js';
import sponsors from './js/widgets/sponsors.js';
import seoWidget from './js/widgets/seoWidget.js';
// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets

$(document).ready(function () {
  // Initialize Custom Theme Scripts
  if (globalThis.location.pathname === '/') {
    mainSlider();
    cardsWidget();
    eventsWidget();
    sponsors();
    $(globalThis).on('load', function () {
      videoWidget();
      socialNetworkWidget.facebookfeed(true);
    });
    hotButtonsWidget();
  }
  seoWidget();
});
